export default "__VITE_ASSET__CpcISnER__"